<template>
    <div class="p-4 rounded shadow-sm rounded-lg bg-white mb-2">
        <router-link to="/loans/request" class="btn btn-dark float-right btn-sm mb-2">Request Loan</router-link>
        <h4 class="font-weight-bold">My Loans</h4>
        <div class="clearfix"></div>

        <alerts :_success="success" :_error="error"></alerts>

        <div v-if="loans.length ==0" class="text-muted">
            No loan records 
        </div>

        <router-link v-for="i in loans" :key="i.id" :to="`/loans/${i.id}`" class="text-secondary">
            <div class="d-flex loans border-bottom rounded-lg p-3 mb-3">
                <div class="py-3 flex-fill">
                    <h5 class="font-weight-bold">{{ i.product.name }}</h5>
                    <p>{{ i.product.name }} - Repayment period {{ i.product.min_period }} <i>to</i>
                        {{ i.product.max_period }} months <br>

                        Applied <span class="font">{{ i.amount }}</span>
                        . paid <span class="font">{{ i.paid }}</span>
                        . balance <span class="font">{{ i.balance }}</span>
                        . interest <span>{{ i.rate }}%</span>
                    </p>

                    <div class="text-muted">
                        <span :class="'status ' + i.status">{{ i.status }}</span>&nbsp;
                        {{ day(i.created_at).format('MMM, DD H:mm') }}
                    </div>
                </div>
                <div class="py-3  ml-md-auto text-md-right">
                    <h6 class="font-weight-bold text-muted">{{ i.serial }}</h6>
                    <h6 class="small text-muted">{{ i.currency }}</h6>
                    <h4 class="font"><u>{{ i.amount }}</u></h4>
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
import Alerts from "@/components/Alerts";

export default {
    name: "Loans",
    components: {Alerts},
    data() {
        return {
            loans: [],
        }
    },
    mounted() {
        this.setLoading()
        this.clear()
        this.success = 'Loading, please wait...'
        this.$http('/user/loans').then(res => {
            this.loans = res.data.data
            this.clear()
        }).catch(err => {
            this.showError(err)
        }).then(() => {
            this.wait = false
        })
    },
    methods: {
        sum(col) {
            return this.loans.reduce(function (a, b) {
                return a + parseFloat(b[col]);
            }, 0);
        }
    }
}
</script>

<style scoped>
@media only screen and (max-width: 480px) {
    .shadow {
        box-shadow: none !important;
    }

    .p-4 {
        padding: 10px !important;
    }
}
</style>